/**
 * 微信分享，qq分享
 * @param shareOptions {Object} - 分享参数
 * @param options.title {String} - 分享标题
 * @param options.desc {String} - 分享简介
 * @param options.link {String} - 分享跳转链接
 * @param options.imgUrl {String} - 分享图片
 * @param options.success {Function} - 用户确认分享后执行的回调函数, 用于埋点
 */

import http from '../js/tools/http'
import { resolveShareLayer } from "./buryingPoint"

const envPrefix = process.env.VUE_APP_RUN_ENV === 'pro' ? '' : process.env.VUE_APP_RUN_ENV

const WX_SHARE_API = `https://${envPrefix}wapapi.nfnews.com/nfplus-wap-api/wx/v2/getShareSignInfo`

// 获取公众号信息
const getWxPublic = () => {
  return new Promise(resolve => {
    let shareUrl = window.location.href.split('#')[0]
    let sendData = {
      shareUrl: encodeURIComponent(shareUrl)
    }
    http
      .get(`${WX_SHARE_API}?shareUrl=${sendData.shareUrl}`, {})
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        window.console.warn(err)
        resolve(false)
      })
  })
}

const wxSahre = (publicInfo, shareOptions) => {
  const onConfiged = ()=>{
    try {
      shareOptions.link = resolveShareLayer(shareOptions.link)
    } catch(err) {
      window.console.error(err)
    }
    const shareSuccess = shareOptions.success
    shareOptions.success = function() {
      shareSuccess && shareSuccess.call(this)
    }
    //分享到朋友圈
    window.wx.onMenuShareTimeline(
      Object.assign({}, shareOptions, {
        shareType: '2',
        shareSuc: 'wx_timeline'
      })
    )
    //分享给朋友
    window.wx.onMenuShareAppMessage(
      Object.assign({}, shareOptions, { shareType: '1', shareSuc: 'wx_chat' })
    )
    //分享到QQ
    window.wx.onMenuShareQQ(
      Object.assign({}, shareOptions, { shareType: '4', shareSuc: 'qq_chat' })
    )
    //分享到腾讯微博
    // window.wx.onMenuShareWeibo(Object.assign({}, shareOptions, { shareType: '2', shareSuc: 'wb' }))
    //分享到QQ空间
    // window.wx.onMenuShareQZone(Object.assign({}, shareOptions, { shareType: '2', shareSuc: 'qq_zone' }))
  }
  if(window.$__nf_wx_sdk_configed) {
    onConfiged();
    return
  }
  
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: publicInfo.app_id, // 必填，公众号的唯一标识
    timestamp: publicInfo.timestamp, // 必填，生成签名的时间戳
    nonceStr: publicInfo.nonceStr, // 必填，生成签名的随机串
    signature: publicInfo.signature, // 必填，签名，见附录1
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ["wx-open-launch-app"]
  })
  window.wx.ready(function() {
    window.console.log('-- wx ready --')
    window.$__nf_wx_sdk_configed = true
    onConfiged();
  })
}

// 设置head的参数，用于qq分享
const setShareHead = shareOptions => {
  let qq_shareName = document.querySelector('meta[itemprop="name"]')
  let qq_shareDescription = document.querySelector(
    'meta[itemprop="description"]'
  )
  let qq_shareImage = document.querySelector('meta[itemprop="image"]')
  qq_shareName.setAttribute('content', shareOptions.title)
  qq_shareDescription.setAttribute('content', shareOptions.desc)
  qq_shareImage.setAttribute('content', shareOptions.imgUrl)
}

const initWxShare = async shareOptions => {
  let getWxPublic_result = await getWxPublic()
  if (!getWxPublic_result) return
  wxSahre(getWxPublic_result, shareOptions)
  setShareHead(shareOptions)
}

export default initWxShare
